import { Country } from 'country-state-city'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

export const getPhoneCountry = values => {
  const country = values.address?.country || values.addresses?.[0]?.country || values.country
  if (typeof country !== 'string') return undefined
  const query = country.trim().toLowerCase()
  return Country.getAllCountries().find(item =>
    item.isoCode.toLowerCase() === query || item.name.toLowerCase() === query
  )?.isoCode
}

export const normalizePhoneNumber = (value, country) => {
  const raw = String(value ?? '').trim()
  if (!raw || raw.startsWith('+') || !country) return raw
  const parsed = parsePhoneNumberFromString(raw, country)
  // Do not turn incomplete/ambiguous values into a different country's number.
  return parsed?.isPossible() && !parsed.ext ? parsed.number : raw
}
